import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

export const generateDocument = async (clientName, answers) => {
    try {
        // 1. Load the template
        const response = await fetch(`/healthcheck/health-check-template.docx?t=${new Date().getTime()}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch template: ${response.statusText}`);
        }
        const content = await response.arrayBuffer();

        // 2. Initialize PizZip and Docxtemplater
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
            delimiters: { start: '[[', end: ']]' }
        });

        // 3. Prepare data for the template
        const data = {
            ClientName: clientName
        };

        // Process answers to combine actions with the answer for 'No' values
        Object.entries(answers).forEach(([key, answer]) => {
            if (answer.value === 'No' && answer.response) {
                // The line break `\n` is handled by the `linebreaks: true` option in Docxtemplater
                data[`${key} answer`] = `No\nAction: ${answer.response}`;
            } else {
                data[`${key} answer`] = answer.value || '';
            }
        });

        // Create a formatted list of all action items for the [[action.list]] placeholder
        const actionItems = Object.entries(answers)
            .filter(([, answer]) => answer.value === 'No' && answer.response)
            .map(([id, answer]) => `${id} - ${answer.response}`);

        if (actionItems.length > 0) {
            // The line breaks are handled by the `linebreaks: true` option in Docxtemplater
            data['action.list'] = actionItems.join('\n\n');
        } else {
            data['action.list'] = 'No action items.';
        }

        // 4. Render the document
        doc.render(data);

        // 5. Generate and save the file
        const out = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yyyy = now.getFullYear();
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');

        const timestamp = `${dd}${mm}${yyyy}${HH}${min}`;
        const filename = `${clientName.replace(/\s+/g, '_')}_${timestamp}.docx`;

        saveAs(out, filename);

    } catch (error) {
        console.error('Error generating document:', error);
        alert('Failed to generate document. See console for details.');
    }
};
